<template>
  <div
    class="block block-rounded mb-4"
    role="region"
    aria-label="Leave calendar"
  >
    <div class="block-header block-header-default">
      <h3 class="block-title">
        Leave Calendar
      </h3>
    </div>
    <div class="block-content">
      <vc-calendar
        :initial-page="calendarPage"
        :attributes="attributes"
        :masks="masks"
        @dayclick="onDayClick"
      />
      <!-- <div class="d-flex gap-3 mt-2 small text-muted">
        <span><span class="d-inline-block rounded px-2 py-1 bg-primary opacity-75 me-1" /> Vacation</span>
        <span><span class="d-inline-block rounded px-2 py-1 bg-warning opacity-75 me-1" /> Sick Leave</span>
      </div> -->
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";

export default {
    name: "VacationCalendar",
    props: {
        staffId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            calendarPage: { month: moment().month() + 1, year: moment().year() },
            masks: {
                weekdays: "WW",
            },
        };
    },
    computed: {
        vacationList() {
            return this.$store.getters["vacation/vacationList"];
        },
        sickLeaveList() {
            return this.$store.getters["vacation/sickLeaveList"];
        },
        approvedVacations() {
            return this.vacationList.filter((v) => v.is_approved === 1 && !v.is_rejected);
        },
        approvedSick() {
            return this.sickLeaveList.filter((v) => v.is_approved === 1 && !v.is_rejected);
        },
        attributes() {
            const attrs = [];
            for (const v of this.approvedVacations) {
                attrs.push({
                    key: `v-${v.id}`,
                    highlight: { color: "blue", fillMode: "light" },
                    dates: { start: new Date(v.start_date), end: new Date(v.end_date) },
                });
            }
            for (const v of this.approvedSick) {
                attrs.push({
                    key: `s-${v.id}`,
                    highlight: { color: "orange", fillMode: "light" },
                    dates: { start: new Date(v.start_date), end: new Date(v.end_date) },
                });
            }
            return attrs;
        },
    },
    methods: {
        onDayClick(day) {
            if (day?.date) {
                this.$emit("request-leave", day.date);
            }
        },
    },
};
</script>
